import { Input } from 'antd';
import { normalize } from './normalize';
import type { StringField } from './types';

/**
 * Human-dictated codes: admission numbers, invoice refs, receipt numbers.
 * Monospace so a `0` and an `O` never argue on the phone; uppercased so
 * `abc-1` and `ABC-1` are the same record.
 */
export function CodeField({ value, onChange, onBlur, ...rest }: StringField) {
  return (
    <Input
      value={value}
      onChange={(e) => onChange?.(normalize(e.target.value, ['upper']))}
      onBlur={() => {
        if (typeof value === 'string') {
          const cleaned = normalize(value, ['trim', 'upper']);
          if (cleaned !== value) onChange?.(cleaned);
        }
        onBlur?.();
      }}
      style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", letterSpacing: 0.3 }}
      {...rest}
    />
  );
}
